import React from "react";
import Flagship from "../../core/flagship";
import { Image, Popup } from "semantic-ui-react";
import { empty } from "../../utils/helpers";

class UserCircle extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.getUserFromId = this.getUserFromId.bind(this);
  }

  getInitialState() {
    return {
      userData:
        typeof this.props.userData === "object" ? this.props.userData : {}
    };
  }

  componentDidMount() {
    this.getUserFromId();
  }

  componentDidUpdate(prevProps) {
    if (this.props.userId !== prevProps.userId) {
      this.getUserFromId();
    }
  }

  getUserFromId() {
    let id = this.props.userId;
    let self = this;
    Flagship.get(
      "user/" + id,
      {},
      function(response) {
        if (response.data.success === true) {
          let userData = Object.assign({}, response.data.user);

          if (!empty(userData)) {
            userData.text = userData.first_name + " " + userData.last_name;
          }

          self.setState({
            userData
          });
        }
      },
      function(err) {
        Flagship.error(
          "Error getting user data: " + err,
          id,
          self.props.userId
        );
      }
    );
  }

  render() {
    let defaultImage = this.props.hasOwnProperty("defaultImage")
      ? this.props.defaultImage
      : "someone.png";

    if (!empty(this.state.userData)) {
      return (
        <Popup
          content={
            <div>
              {this.props.contentLabel} {this.state.userData.text}
            </div>
          }
          trigger={
            <Image
              avatar
              src={
                Flagship.config.uploads +
                (!empty(this.state.userData.photo)
                  ? this.state.userData.photo
                  : defaultImage)
              }
              size="mini"
              className="circular assignee-image"
            />
          }
        />
      );
    } else {
      return (
        <Popup
          content="Getting User Data..."
          trigger={
            <Image
              avatar
              src={Flagship.config.uploads + "someone.png"}
              size="mini"
              className="circular assignee-image"
            />
          }
        />
      );
    }
  }
}

export default UserCircle;



// WEBPACK FOOTER //
// ./src/components/misc/UserCircle.js